'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _Loading = require('../../Loading');

var _Loading2 = _interopRequireDefault(_Loading);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = {
  inputContainer: {
    overflow: 'hidden',
    cursor: 'pointer',
    position: 'relative',
    borderRadius: 5,
    padding: 8,
    fontSize: 18,
    color: '#a9a9a9',
    backgroundColor: '#fff',
    border: '1px solid #c2c2c2'
  },
  input: {
    cursor: 'pointer',
    display: 'block',
    fontSize: 20,
    filter: 'alpha(opacity=0)',
    minHeight: '100%',
    minWidth: '100%',
    opacity: 0,
    position: 'absolute',
    right: 0,
    textAlign: 'right',
    top: 0
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    padding: 10
  }
};

var Component = (_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Component, _React$Component);

  function Component() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Component);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Component, [{
    key: 'onChange',
    value: function onChange(event) {
      var _this2 = this;

      var file = event.target.files[0];
      if (!file) return;
      this.setState({ uploading: true, fileName: file.name });
      this.props.upload({
        file: file,
        onProgress: function onProgress(progress) {
          _this2.setState({ progress: progress });
        },
        onReady: function onReady(file) {
          _this2.props.onChange(file);
        },
        onError: function onError(message) {
          console.log(message);
          _this2.setState({ uploading: false, errorMessage: message });
        }
      });
    }
  }, {
    key: 'renderInput',
    value: function renderInput() {
      return _react2.default.createElement('input', { type: 'file', style: styles.input, onChange: this.onChange });
    }
  }, {
    key: 'renderPlaceholderOrName',
    value: function renderPlaceholderOrName() {
      if (!this.state.fileName) {
        return this.props.placeholder;
      } else {
        var style = this.state.uploading ? { color: '#a9a9a9' } : { color: '#000' };
        return _react2.default.createElement(
          'div',
          { style: (0, _extends3.default)({}, style, styles.fileNameContainer) },
          _react2.default.createElement(
            'div',
            null,
            this.state.fileName
          ),
          _react2.default.createElement(
            'div',
            { style: styles.loading },
            _react2.default.createElement(_Loading2.default, {
              size: 25,
              mode: 'determinate',
              color: '#0069ff',
              value: this.state.progress * 0.95 * 100 + 5 })
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: styles.inputContainer },
          this.renderPlaceholderOrName(),
          this.renderInput()
        )
      );
    }
  }]);
  return Component;
}(_react2.default.Component), _class2.propTypes = {
  placeholder: _propTypes2.default.node,
  upload: _propTypes2.default.func,
  onChange: _propTypes2.default.func
}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'onChange', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onChange'), _class.prototype)), _class);
exports.default = Component;


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/components/fields/File/Input.js
// module id = 2580
// module chunks = 0